import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import * as D from '../../deps';

export class BackstagePodcastSidebarButtons extends React.Component {
  static propTypes = {
    addCollectionItem: PropTypes.func,
    hasOnlyRetiredContent: PropTypes.bool,
    inCollection: PropTypes.bool.isRequired,
    isPaused: PropTypes.bool.isRequired,
    isPlayingCurrently: PropTypes.bool.isRequired,
    isProgram: PropTypes.bool.isRequired,
    openShareModal: PropTypes.func,
    pandoraId: PropTypes.string.isRequired,
    pauseTrack: PropTypes.func,
    playResumeSource: PropTypes.func,
    podcastTitle: PropTypes.string,
    removeCollectionItem: PropTypes.func,
  };

  static contextType = D.Utils.Context.AppContext;

  componentEventLogHandler = componentEventType => {
    this.context.integration.action.clicked({
      pandoraId: this.props.pandoraId,
      contentSection: D.Constants.ContentSections.BackstageContentSections.CONTROL_BAR,
      componentEventType,
    });
  };

  addToMusicOnClick = () => {
    this.props.addCollectionItem({ pandoraId: this.props.pandoraId });
    this.componentEventLogHandler(D.Constants.SourceCard.SourceCardConstants.ADDTOCOLLECTION);
  };

  removeFromMusicOnClick = () => {
    this.props.removeCollectionItem({ pandoraId: this.props.pandoraId });
    this.componentEventLogHandler(D.Constants.SourceCard.SourceCardConstants.REMOVEFROMCOLLECTION);
  };

  playOnClick = () => {
    this.props.playResumeSource({
      id: this.props.pandoraId,
      context: D.Constants.Ads.Rewards.ContextTypes.BACKSTAGE,
    });
    this.componentEventLogHandler(D.Constants.AudioPlayer.AudioPlayerActions.AUDIO_PLAY_TRACK);
  };

  pauseOnClick = () => {
    this.props.pauseTrack();
    this.componentEventLogHandler(D.Constants.AudioPlayer.AudioPlayerActions.PAUSE);
  };

  shareOnClick = () => {
    this.props.openShareModal(this.props.pandoraId);
    this.componentEventLogHandler(D.Constants.SourceCard.SourceCardConstants.SHARE);
  };

  render() {
    const {
      inCollection,
      hasOnlyRetiredContent,
      isProgram,
      isPlayingCurrently,
      isPaused,
      podcastTitle,
    } = this.props;

    const addToMusicOnClick = !inCollection ? this.addToMusicOnClick : noop;
    const removeFromMusicOnClick = inCollection ? this.removeFromMusicOnClick : noop;
    const playOnClick =
      (hasOnlyRetiredContent && isProgram) || !isPlayingCurrently || isPaused
        ? this.playOnClick
        : noop;
    const pauseOnClick =
      (!hasOnlyRetiredContent || !isProgram) && isPlayingCurrently && !isPaused
        ? this.pauseOnClick
        : noop;
    const shareOnClick = this.shareOnClick;

    let disabledButtons = [];
    if (hasOnlyRetiredContent && isProgram) {
      disabledButtons = [
        D.ButtonRowType.ADD_TO_COLLECTION,
        D.ButtonRowType.PLAY,
        D.ButtonRowType.PAUSE,
        D.ButtonRowType.SHARE,
      ];
    } else if (hasOnlyRetiredContent) {
      disabledButtons = [D.ButtonRowType.ADD_TO_COLLECTION, D.ButtonRowType.SHARE];
    }

    return (
      <D.ButtonRowWithLogger
        addToMusicOnClick={addToMusicOnClick}
        removeFromMusicOnClick={removeFromMusicOnClick}
        playOnClick={playOnClick}
        pauseOnClick={pauseOnClick}
        shareOnClick={shareOnClick}
        buttonTextType={D.ButtonTextType.PLAY_PODCAST}
        disabledButtons={disabledButtons}
        isSidebar={true}
        entityName={podcastTitle}
      />
    );
  }
}

export function mapStateToProps(state, ownProps) {
  const annotation = D.getAnnotationsById(state, ownProps.pandoraId);
  const isProgram =
    D.Utils.Core.getFromMap(annotation, 'type') === D.Constants.SourceTypes.PandoraTypes.PODCAST;
  const programId = isProgram
    ? ownProps.pandoraId
    : D.Utils.Core.getFromMap(annotation, 'podcastId');

  return {
    hasOnlyRetiredContent: D.Utils.Rights.isRetired(annotation),
    inCollection: D.getInDomain('collection.utils.isPandoraIdInCollection', false)(
      state,
      ownProps.pandoraId,
    ),
    isPaused: !D.PlaybackUtils.isAudioPlaying(state),
    isPlayingCurrently: D.PlaybackUtils.isSourcePlayingCurrently(state, programId),
    isProgram,
    programId,
  };
}

const mapDispatchToProps = {
  addCollectionItem: D.Actions.Collection.addCollectionItem,
  openShareModal: D.Actions.Share.openShareModal,
  pauseTrack: D.Actions.UseCases.pauseTrack,
  playResumeSource: D.Actions.UseCases.playResumeSource,
  removeCollectionItem: D.Actions.Collection.removeCollectionItem,
};

export default connect(mapStateToProps, mapDispatchToProps)(BackstagePodcastSidebarButtons);
